import { createElement, forwardRef } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import invariant from 'invariant';

import useUser from 'Hooks/useUser';

export default function withUser(Component) {
  const displayName = `withUser(${ (Component.displayName || Component.name || 'Component') })`;

  const WithUser = forwardRef((props, ref) => {
    const userContext = useUser();
    invariant(userContext, `You should not use <${displayName} /> outside a <UserProvider />`);
    return createElement(Component, {
      userContext,
      ref,
      ...props
    });
  });

  WithUser.displayName = displayName;
  WithUser.WrappedComponent = Component;

  return hoistNonReactStatics(WithUser, Component);
}
